export default __webpack_public_path__ + "static/media/CasinoverseGlobe.3eea7e68.webp";